import BoolProp from "./bool_prop";
import TextProp from "./text_prop";
import DomainProp from "./domain_prop";
import React from "react";
import DisplayProp from "./display_prop";
import TtPosIcon from "../../planitems/icons/domino/tt_pos_icon";
import {hasAccessory, hasBM} from "../../../bidib/bidib_commons";
import {connect} from "react-redux";

const Propsline = ({item, itm, domain, onChange, array, arrayindex}) => {

    let editfield = null

    const _item = item || {}


    if (itm.datatype === 'bool') {
        editfield = <BoolProp key={itm.datatype} propertyname={itm.name} array={array} arrayindex={arrayindex}
                              value={item[itm.name]} default_={itm.default}
                              onChange={onChange}/>
    } else if (itm.datatype === 'text') {

        /*
        console.log("item[itm.datatype]")
        console.log(item)
        console.log(itm)
        console.log(itm.datatype)
        console.log(item[itm.datatype])
        */

        editfield = <TextProp key={itm.datatype} propertyname={itm.name} array={array} arrayindex={arrayindex}
                              value={item[itm.name]} default_={itm.default}
                              onChange={onChange}/>
    } else if (itm.datatype === 'domain') {
        let dval = []
        if (itm.domain instanceof Array) {
            dval = itm.domain
        } else {
            dval = domain[itm.domain]
        }
        editfield = <DomainProp key={itm.type}
                                propertyname={itm.name}
                                array={array}
                                arrayindex={arrayindex}
                                value={item[itm.name]}
                                default_={itm.default}
                                domain={dval}
                                item={_item}
                                onChange={onChange}/>
    } else if (itm.datatype === 'display') {
        editfield = <DisplayProp key={itm.type} propertyname={itm.name} value={item[itm.name]}/>
    } else if (itm.datatype === 'adressport') {

        let dval = []
        if (itm.field_a.domain instanceof Array) {
            dval = itm.field_a.domain
        } else {
            dval = domain[itm.field_a.domain]
        }

        editfield = <>
            <DomainProp key={itm.field_a.name} propertyname={itm.field_a.name} array={array} arrayindex={arrayindex}
                        value={item[itm.field_a.name]} default_={itm.field_a.default}
                        domain={dval}
                        item={_item}
                        onChange={onChange} width={100}/>
            <TextProp key={itm.field_b.name} propertyname={itm.field_b.name} array={array} arrayindex={arrayindex}
                      value={item[itm.field_b.name]} default_={itm.field_b.default}
                      onChange={onChange} width={30}/>


        </>
    } else if (itm.datatype === 'trigger') {

        let dval = []
        if (itm.field_a.domain instanceof Array) {
            dval = itm.field_a.domain
        } else {
            dval = domain[itm.field_a.domain]
        }
        editfield = <>
            <DomainProp key={itm.field_a.name} propertyname={itm.field_a.name} array={array} arrayindex={arrayindex}
                        value={item[itm.field_a.name]} default_={itm.field_a.default}
                        domain={dval}
                        item={_item}
                        onChange={onChange} width={100}/>
            <TextProp key={itm.field_b.name} propertyname={itm.field_b.name} array={array} arrayindex={arrayindex}
                      value={item[itm.field_b.name]} default_={itm.field_b.default}
                      onChange={onChange} width={30}/>
            <TextProp key={itm.field_c.name} propertyname={itm.field_c.name} array={array} arrayindex={arrayindex}
                      value={item[itm.field_c.name]} default_={itm.field_c.default}
                      onChange={onChange} width={30}/>
            <TextProp key={itm.field_d.name} propertyname={itm.field_d.name} array={array} arrayindex={arrayindex}
                      value={item[itm.field_d.name]} default_={itm.field_d.default}
                      onChange={onChange} width={30}/>

        </>
    } else if (itm.datatype === 'array') {
        let ttpos = []
        if (item[itm.domain] instanceof Array) {

            let itemdomain = item[itm.domain]

            //console.log(itemdomain)
            //itemdomain = itemdomain ? itemdomain.sort((a,b) => parseInt(a.ang) - parseInt(b.ang)) : []
            //console.log(itemdomain)

            for (let ttp of itemdomain) {
                for (let prop of itm.fields) {
                    ttpos.push(<Propsline key={ttp.id + "_" + prop.name} itm={prop} array={itm.datatype}
                                          arrayindex={parseInt(ttp.id)} item={ttp} domain={domain}
                                          onChange={onChange}/>)
                }
            }

            const ttpx = {
                id: String(item[itm.domain].length),
                ang: 0,
            }
            for (let prop of itm.fields) {
                ttpos.push(<Propsline key={ttpx.id + "_" + prop.name+"_x"} itm={prop} array={itm.datatype}
                                      arrayindex={parseInt(ttpx.id)} item={ttpx} domain={domain}
                                      onChange={onChange}/>)
            }
        }
        editfield = <>{ttpos}</>
    }
    /* <DisplayProp key={itm.name} propertyname={itm.field_a.name} value={item[itm.field_a.name]}/> */
    // +"["+ttp.id+"]."

    const _isarray = itm.type === 'array'

    return (

        _isarray?<div style={{
                minWidth: '400px',
                display: 'block',
                margin: '5px',
                padding: '7px',
                border: '1px solid #000000',
                borderRadius: '3px',
                background: '#446677',
                maxHeight: '500px',
                overflow: 'auto',
            }}>
            <span style={{
                minWidth: '600px',
                maxWidth: '600px',
                width: '600px',
                fontWeight: 'bold',
                marginRight: '5px',
            }}>
                {itm.name}:
            </span>
                <span style={{
                    //width: '150px',
                    //display: 'inline',
                    //float: 'right',

                }}>
                {editfield}

            </span>
            </div>:

        <div style={{
            minWidth: '400px',
            display: 'block',
            margin: '5px',
            padding: '7px',
            //border: '1px solid #000000',
            //borderRadius: '3px',
            borderBottom: '1px solid #000000',
            marginRight: '15px',
            alignItems: 'center',
        }}>
            <span style={{
                //minWidth: '600px',
                //maxWidth: '600px',
                width: '600px',
                fontWeight: 'bold',
                marginRight: '5px',

            }}>
                {itm.name}
            </span>
            <span style={{
                //width: '150px',
                //display: 'inline',
                float: 'right',
                marginRight: '15px',
            }}>
                {editfield}

            </span>
        </div>

    )
}

export default Propsline


